var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"d-flex flex-column flex-grow-1"},[_c('BroadcastHeader'),_c('BroadcastList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }